import '~/pages/projects';
import { initTrialStatusWidgetAndPopover } from 'ee/contextual_sidebar/init_trial_status_widget_and_popover';

initTrialStatusWidgetAndPopover();
